<template>
  <div class="shaow" v-if="isShow">
    <div class="notice-layout">
      <div class="notice-bg" v-if="type == 'notice'">
        <div class="close-btn" @click="isShow = false"></div>
        <div class="notice-swipe">
          <van-swipe>
            <van-swipe-item v-for="(item, index) in newsData" :key="index">
              <div class="content" v-safe-html="item.content"></div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div class="newVersion-bg" v-if="type == 'newVersion'">
        <div class="close-btn" @click="isShow = false"><van-icon name="cross" /></div>
        <div class="content">
          <div class="coverImg">
            <img src="~@/assets/img/home/huojian.png" alt="" />
          </div>
          <h1>发现新版本</h1>
          <h4>v1.5.8</h4>
          <div class="column">
            <div class="item">客户端视觉ui全面升级</div>
            <div class="item">客户端用户体验优化</div>
            <div class="item">新增AI功能及加强数据安全</div>
            <div class="item">新增加密货币充值提现渠道，提升用户资金到账时速</div>
          </div>
          <div class="full-btn mt_5">立即升级</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, defineProps, ref } from 'vue';
import { useMsgStore } from '@star/stores';

const props = defineProps({
  type: {
    type: String,
  },
});

const msgStore = useMsgStore();
const isMore = ref(false);

var isShow = ref(false);
const newsData = computed(() => {
  let newsData = [];
  for (let i = 0; i < msgStore.newLists.length; i++) {
    let item = msgStore.newLists[i];
    if (item.ma_id !== 8) {
      if (item.content) {
        item.content = item.content.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
      }
      newsData.push(item);
    }
  }
  if (!isMore.value) {
    newsData = newsData.filter(v => Number(v.is_pop_up) > 0);
  }
  console.log(newsData, 'newsData');
  return newsData;
  // 控制是否显示，通过showGameNotice控制
});
</script>

<style lang="less" scoped>
.newVersion-bg {
  width: 86%;
  height: 1200px;
  background: url('@/assets/img/home/newVersion-bg.png');
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  box-sizing: border-box;
  border-radius: 30px;
  .coverImg {
    width: 400px;
    position: absolute;
    right: 0;
    top: -60px;
    img {
      width: 100%;
    }
  }
  .content {
    padding: 40px 80px;
    .column {
      margin-top: 50px;
      .item {
        line-height: 90px;
        font-size: 46px;
      }
      .item::before {
        content: '';
        width: 20px;
        height: 20px;
        background: #38e6fe;
        display: inline-block;
        border-radius: 50%;
      }
    }
  }
  .close-btn {
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    background: #fff;
    position: absolute;
    right: 0;
    left: 0;
    border-radius: 50%;
    bottom: -150px;
    margin: auto;
    i {
      font-size: 80px;
      margin-top: 20px;
    }
  }
}
.notice-bg {
  width: 86%;
  height: 1300px;
  background: url('@/assets/img/home/notice-bg.png');
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  box-sizing: border-box;
  border-radius: 30px;

  .notice-swipe {
    margin-top: 220px;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
    }
  }

  .content {
    width: 94%;
    height: 1000px;
    margin: 0 auto;
    padding: 50px;
    word-wrap: break-word;
    border-radius: 50px 50px 0 0;
    background: #fff;
  }

  .close-btn {
    width: 80px;
    height: 80px;

    position: absolute;
    right: 60px;
    top: 100px;
  }
}
</style>
